<template>
  <v-card tile>
    <v-toolbar card dark :color="temaColor">
      <v-toolbar-title>OCR Empadronamiento</v-toolbar-title>
      <v-spacer></v-spacer>
      <span v-if="isSuccess || isFailed">
        <v-btn icon @click="reset">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn :disabled="isSaved" icon @click="save">
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
        <!-- <v-btn icon @click="drive">
                    <v-icon>mdi-cloud-upload</v-icon>
                </v-btn> -->
      </span>
      <v-btn icon dark @click.native="closeDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12>
            <!-- <template v-if="!FilesUpSelected"> -->
            <template v-if="isInitial">
              <h2 class="blue--text  font-weight-light pb-2">
                Selecciona el Archivo
              </h2>
              <!-- <h2  v-else class="blue--text  font-weight-light pb-2">{{ `Encontrada la Ref.: ${catastroKey} con ${numInmuebles} inmuebles` }}</h2> -->
              <div class="dropbox">
                <input
                  v-if="!FilesUpSelected"
                  accept="image/*"
                  class="font-weight-light input-file"
                  type="file"
                  @change="onFileChange"
                />
                <p>
                  Arrastra aquí el archivo<br />
                  o haz click
                </p>
              </div>
            </template>
            <div v-if="isSaving">
              <div class="container text-xs-center">
                <v-progress-circular
                  v-bind:size="200"
                  v-bind:width="15"
                  v-bind:rotate="-90"
                  v-bind:value="progressData.progress * 100"
                  color="primary"
                >
                  {{ progress || 0 }} %
                </v-progress-circular>
                <h2>{{ progressText }}</h2>
              </div>
              <!-- <span>{{ FilesUpSelected.name }}</span><br/>
                            <v-btn class="red white--text" @click="removeFile">Eliminar</v-btn>
                            <v-btn color="blue darken-1" @click.native="submitFiles">Guardar</v-btn> -->
            </div>
          </v-flex>
          <!-- Resultados -->
          <v-container fluid grid-list-md v-if="isSuccess || isFailed">
            <v-layout wrap v-for="(item, i) in result" :key="i" class="mb-5">
              <v-flex xs8>
                <v-layout wrap>
                  <v-flex xs5>
                    <v-text-field
                      @input="forceUppercase($event, item, 'nombre')"
                      label="Nombre"
                      v-model="item.nombre"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs7>
                    <v-text-field
                      @input="forceUppercase($event, item, 'apellido1')"
                      label="Apellido 1"
                      v-model="item.apellido1"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs7>
                    <v-text-field
                      @input="forceUppercase($event, item, 'apellido2')"
                      label="Apellido 2"
                      v-model="item.apellido2"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field
                      @input="forceUppercase($event, item, 'nif')"
                      label="NIF"
                      v-model="item.nif"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs4>
                <v-card color="grey lighten-4" height="20vh">
                  <v-container fluid class="px-2">
                    <v-layout row wrap>
                      <v-flex xs12>
                        Fecha de Nacimiento:
                      </v-flex>
                      <v-flex xs3>
                        <!-- <v-text-field label="Dia" ></v-text-field> -->
                        <v-autocomplete
                          v-model="item.fechaNacimientoDia"
                          :items="fechaNac.dias"
                          label="Dia"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs3>
                        <!-- <v-text-field label="Mes" ></v-text-field> -->
                        <v-autocomplete
                          v-model="item.fechaNacimientoMes"
                          :items="fechaNac.meses"
                          label="Mes "
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs6>
                        <!-- <v-text-field label="Año" ></v-text-field> -->
                        <v-autocomplete
                          v-model="item.fechaNacimientoYear"
                          :items="fechaNac.years"
                          label="Año"
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
// import Tesseract from 'tesseract.js';
// import Tesseract from 'tesseract-vue';
// var Tesseract = require("tesseract-vue")
import { completaNif, aleatorioId, fechaObject } from "@/plugins/functions.js";
import { dbFB } from "@/components/firebase.js";
import { mapState } from "vuex";
const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;
export default {
  props: ["data"],
  // components: {Tesseract},
  data() {
    return {
      FilesUpSelected: null,
      progressData: {},
      result: null,
      resultOld: [
        {
          apellido1: "IZQUIERDO",
          apellido2: "ROMERO",
          nombre: "BENITO",
          nif: "12345678A",
          fechaNacimientoDia: 9,
          fechaNacimientoMes: 3,
          fechaNacimientoYear: 1956,
          sexo: 1
        },
        {
          apellido1: "MORENO",
          apellido2: "GARCÍA",
          nombre: "Mª LUISA",
          nif: "12345678B",
          fechaNacimientoDia: 5,
          fechaNacimientoMes: 10,
          fechaNacimientoYear: 1959,
          sexo: 0
        }
      ],
      currentStatus: null,
      textSuccess: [
        {
          en: "recognizing text",
          es: "reconociendo texto"
        },
        {
          en: "initializing api",
          es: "inicializando..."
        }
      ],
      fechaNac: {
        dias: [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31
        ],
        meses: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        years: []
      },
      sexoSelect: ["MUJER", "HOMBRE"],
      isSaved: false
    };
  },
  created() {
    this.autocompleteFecha();
  },
  mounted() {
    this.reset();
  },
  computed: {
    ...mapState(["navegationControl", "configApp"]),
    temaColor() {
      return this.$store.getters.getTemaColorAdminUI;
    },
    uid() {
      return this.$store.getters.getUserUid;
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    progress() {
      return Math.floor(this.progressData.progress * 100);
    },
    progressText() {
      const txt = this.progressData.status;
      return this.textSuccess
        .filter(item => item.en.includes(txt))
        .map(item => item.es)[0];
    },
    modeloUsuario() {
      return JSON.parse(JSON.stringify(this.configApp.userModel)) || false;
    }
  },
  methods: {
    closeDialog() {
      this.reset();
      this.$emit("closeDialog");
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.FilesUpSelected = files[0];
      if (!window.File) {
        alert("La API File no está soportada");
        return;
      }
      this.currentStatus = STATUS_SAVING;
      this.procesaImagen();
    },
    procesaImagen() {
      const that = this;
      window.Tesseract.recognize(this.FilesUpSelected, {
        lang: "spa"
      })
        .progress(data => {
          // that.currentStatus = STATUS_SUCCESS
          that.progressData = data;
        })
        .then(function(data) {
          // that.result = data
          that.currentStatus = STATUS_SUCCESS;
          that.procesaResultado(data);
        })
        .catch(error => {
          that.currentStatus = STATUS_FAILED;
          that.progressData = error;
        });
    },
    procesaResultado(data) {
      const lines = data && data.blocks ? data.blocks[0].lines : [];
      let datosExtraidos = [];
      if (lines.length > 0) {
        let counter = 0;
        for (const line of lines) {
          const txt = line.text;
          counter++;
          if (txt.indexOf("orden Nombre y apellidos") > -1) {
            const nacimiento = this.parserData(lines[counter + 2].text, 2);
            let result = this.parserData(lines[counter].text, 1);
            if (nacimiento && nacimiento !== "Error") {
              const keys = Object.keys(nacimiento);
              for (const key of keys) {
                result[key] = nacimiento[key];
              }
            }
            datosExtraidos.push(result);
          }
        }
      }
      if (datosExtraidos.length > 0) {
        this.result = datosExtraidos;
      }
    },
    parserData(data, option) {
      let result = {};
      // Nombre y apellidos + Sexo + DNI
      if (option === 1) {
        // "1 M. LUISA USERA CLAVERO MUJER 36931281\n"
        const sexo = data.includes("MUJER")
          ? 0
          : data.includes("HOMBRE")
          ? 1
          : false;
        const campos =
          sexo === 0
            ? data.split("MUJER")
            : sexo
            ? data.split("HOMBRE")
            : false;
        if (!campos) {
          return "Error";
        }
        // na => Nombre y Apellidos
        const na = campos[0].trim().split(" ");
        const apellido2 = na[na.length - 1];
        const apellido1 = na[na.length - 2];
        let nombre = "";
        for (let index = 1; index < na.length - 2; index++) {
          nombre += ` ${na[index]}`;
        }
        nombre = nombre.trim();
        // dni
        let dni = campos[1].trim().split("\n");
        dni = dni[0];
        if (dni && dni.length >= 8) {
          dni = completaNif(dni.substr(0, 8));
        }
        result = {
          nombre: nombre,
          apellido1: apellido1,
          apellido2: apellido2,
          nif: dni,
          direccion: this.data.direccion,
          sexo: sexo,
          inmuebles: {
            [this.data.refCatastralCompleta]: {
              idInmueble: this.data.ref,
              refCatastral: this.data.refCatastral
            }
          }
        };
      }

      // "07/10/1957 BARCELONA (BARCELONA) ESPAÑA\n"
      if (option === 2) {
        "07/10/1957 BARCELONA (BARCELONA) ESPAÑA\n".substr(0, 10);
        let fecha = data.substr(0, 10);
        fecha = fecha.split("/");
        if (!fecha || fecha.length !== 3) {
          return "Error";
        }
        result = {
          fechaNacimientoDia: parseInt(fecha[0]),
          fechaNacimientoMes: parseInt(fecha[1]),
          fechaNacimientoYear: parseInt(fecha[2])
        };
      }
      return result;
    },
    removeFile() {},
    submitFiles() {},
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.progressData = {};
      this.result = null;
      this.isSaved = false;
    },
    save() {
      const modeloUsuario = Object.assign({}, this.modeloUsuario);
      if (!modeloUsuario) {
        return;
      }
      let catUsers = [];
      this.result.forEach(item => {
        let userData = modeloUsuario;
        userData.private = Object.assign({}, JSON.parse(JSON.stringify(item)));
        const aleat = aleatorioId(this.uid);
        const date = fechaObject().timeStamp;
        const cadena = window.btoa(`${aleat}${date}`.toString());
        const userUid = `OCR-${cadena}`;
        catUsers.push({
          cuota: 0,
          discapacidad: false,
          empadronado: true,
          id: userUid,
          mayor65: false,
          padronStatusConocido: 2,
          tipo: 0,
          volante: true
        });
        // eslint-disable-next-line
                // console.log(JSON.stringify(userData))
        dbFB
          .ref("users")
          .child(userUid)
          .set(userData);
      });
      // Catastro
      dbFB
        .ref("catastro")
        .child(this.data.refCatastral)
        .child("catastroUsers")
        .child(this.data.ref)
        .set(catUsers);
      this.isSaved = true;
      this.closeDialog();
    },
    drive() {},
    forceUppercase(e, o, prop) {
      // this.aaa = e
      if (prop === "nif" && o.nif.length === 8) {
        this.$set(o, prop, completaNif(o.nif));
        return;
      }
      //https://forum.vuejs.org/t/inputs-always-in-uppercase-using-v-model/7450/9
      e = e.toUpperCase();
      this.$set(o, prop, e);
    },
    autocompleteFecha() {
      const actualYear = new Date().getFullYear();
      const rango = 120;
      this.fechaNac.years = [];
      for (let index = actualYear; index > actualYear - rango; index--) {
        this.fechaNac.years.push(index);
      }
    }
  }
};
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: transparent;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: rgba(
    255,
    255,
    255,
    0.1
  ); /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
